import { useEffect, useState } from 'react';

import { TASKS } from 'constants/Entities';
import Context from 'managers/Context';

const getTaskContact = (data) => {
    const id = data?.idContact ?? data?.idContacto ?? data?.IdContact;
    const rawContact = data?.contact;
    const rawLabel =
        typeof rawContact === 'string'
            ? rawContact
            : (rawContact?.label ?? data?.contactName ?? data?.contacto);
    const label = typeof rawLabel === 'string' ? rawLabel : '';

    if (!id || String(id) === '-1') return null;

    return { label, value: id };
};

const useTaskPopoverContact = (data) => {
    const [contact, setContact] = useState(() => getTaskContact(data));

    useEffect(() => {
        const initialContact = getTaskContact(data);
        setContact(initialContact);

        if (!data?.isTarea || initialContact?.label || !data?.Id) return undefined;

        let isMounted = true;
        Context.domainManager.getEntity(
            data.Id,
            TASKS.entity,
            true,
            (task) => {
                if (isMounted) setContact(getTaskContact(task));
            },
            () => {},
        );

        return () => {
            isMounted = false;
        };
    }, [data]);

    return contact;
};

export default useTaskPopoverContact;
